import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { Form, FormGroup, Label, Input, Col, Row, Button } from "reactstrap";
import Modal from "../../../Basic/Modal";
import CommonLoad from "../../../Basic/Spin";
import GeoSearch from "../../../Basic/GeoSearch";
import Notification from "../../../Basic/Notification";
import { addPlantApi, updatePlantApi } from "../../api";

var PlantModal = /*#__PURE__*/function (_Component) {
  _inherits(PlantModal, _Component);

  var _super = _createSuper(PlantModal);

  function PlantModal() {
    var _this;

    _classCallCheck(this, PlantModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      plant: {},
      subscriptionKey: localStorage.getItem('subscriptionKey'),
      loadFromName: Date.now(),
      initValue: '',
      nameValid: _this.props.modalType === 'add' ? false : true,
      nameMsg: '',
      addressValid: true,
      addressMsg: '',
      loading: false
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (e) {
      var _e$target = e.target,
          name = _e$target.name,
          value = _e$target.value;
      var value1 = value.replace(/^\s+/, '');

      var plant = _objectSpread(_objectSpread({}, _this.state.plant), _defineProperty({}, name, value1));

      _this.setState({
        plant: plant
      });

      if (name === 'Name') {
        _this.validateName(value1);
      } else {
        _this.validateAddress(value1);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "validateName", function (value) {
      if (!value.trim().length) {
        _this.setState({
          nameValid: false,
          nameMsg: _this.props.translate('SFxAccountSettingsValidatePlantRequired')
        });
      } else if (value.trim().length <= 50) {
        if (_this.props.plantList.findIndex(function (item) {
          return item.Name === value.trim();
        }) > -1 && value.trim() !== _this.props.selectedPlant.Name) {
          _this.setState({
            nameValid: false,
            nameMsg: _this.props.translate('SFxAccountSettingsValidatePlantUnique')
          });
        } else {
          _this.setState({
            nameValid: true,
            nameMsg: ''
          });
        }
      } else {
        _this.setState({
          nameValid: false,
          nameMsg: _this.props.translate('SFxAccountSettingsValidatePlantLength')
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "validateAddress", function (value) {
      if (value.trim().length > 200) {
        _this.setState({
          addressValid: false,
          addressMsg: _this.props.translate('SFxAccountSettingsValidatePlantAddressLength')
        });
      } else {
        _this.setState({
          addressValid: true,
          addressMsg: ''
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOk", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$state$plant, Name, _this$state$plant$Add, Address, GeoLocation, plant, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                loading: true
              });

              _this$state$plant = _this.state.plant, Name = _this$state$plant.Name, _this$state$plant$Add = _this$state$plant.Address, Address = _this$state$plant$Add === void 0 ? '' : _this$state$plant$Add, GeoLocation = _this$state$plant.GeoLocation;
              plant = {
                Name: Name.trim(),
                Address: Address.trim(),
                GeoLocation: GeoLocation
              };

              if (!(_this.props.modalType === 'add')) {
                _context.next = 20;
                break;
              }

              _context.prev = 4;
              data = _objectSpread(_objectSpread({}, plant), {
                ObjectType: 'Plant'
              });
              _context.next = 8;
              return addPlantApi(data);

            case 8:
              _this.setState({
                loading: false
              });

              _this.props.toggle();

              _this.props.refreshCallback();

              Notification.open({
                description: _this.props.translate('SFxAccountSettingsAddPlantsSuccessMsg')
              });
              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);
              console.log(_context.t0);

              _this.setState({
                loading: false
              });

            case 18:
              _context.next = 33;
              break;

            case 20:
              _context.prev = 20;
              _context.next = 23;
              return updatePlantApi(_objectSpread(_objectSpread({}, _this.state.plant), plant));

            case 23:
              _this.setState({
                loading: false
              });

              _this.props.toggle();

              _this.props.refreshCallback();

              Notification.open({
                description: _this.props.translate('SFxAccountSettingsEditPlantsSuccessMsg')
              });
              _context.next = 33;
              break;

            case 29:
              _context.prev = 29;
              _context.t1 = _context["catch"](20);
              console.log(_context.t1);

              _this.setState({
                loading: false
              });

            case 33:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 14], [20, 29]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleCancel", function () {
      _this.props.toggle();
    });

    _defineProperty(_assertThisInitialized(_this), "handleReset", function () {
      _this.setState({
        plant: _this.props.selectedPlant,
        nameValid: _this.props.modalType === 'add' ? false : true,
        nameMsg: '',
        addressValid: true,
        addressMsg: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectAddress", function (location) {
      _this.validateAddress(location.label);

      _this.setState({
        plant: _objectSpread(_objectSpread({}, _this.state.plant), {}, {
          Address: location.label,
          GeoLocation: location.value
        })
      });
    });

    return _this;
  }

  _createClass(PlantModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleReset();
    } // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState = function () {
        return;
      };
    }
  }, {
    key: "onBlurName",
    value: function onBlurName() {
      if (this.state.plant.Name && !this.state.plant.Address) {
        this.setState({
          initValue: this.state.plant.Name,
          loadFromName: Date.now()
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          toggle = _this$props.toggle,
          modalType = _this$props.modalType,
          prefix = _this$props.prefix,
          selectedPlant = _this$props.selectedPlant,
          translate = _this$props.translate;
      var _this$state = this.state,
          plant = _this$state.plant,
          nameValid = _this$state.nameValid,
          nameMsg = _this$state.nameMsg,
          addressValid = _this$state.addressValid,
          addressMsg = _this$state.addressMsg,
          loading = _this$state.loading;
      var nameTouched = plant.Name && plant.Name.trim() !== selectedPlant.Name;
      var addressTouched = plant.Address !== undefined && plant.Address.trim() !== selectedPlant.Address;
      var touched = nameTouched || addressTouched;
      var canSubmit = nameValid && addressValid && touched;
      var ResetDisabled = !touched;
      var PlantModalTitle = modalType === 'add' ? translate('SFxAccountSettingsPlantAddModalTitle') : translate('SFxAccountSettingsPlantEditModalTitle');
      var footer = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "reset-text"
      }, /*#__PURE__*/React.createElement("span", {
        onClick: this.handleReset,
        className: "reset-button ".concat(ResetDisabled ? 'reset-disabled' : '')
      }, translate('SFxAccountSettingsResetButtonText'))), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
        color: "secondary",
        size: "sm",
        onClick: this.handleCancel
      }, translate('SFxAccountSettingsCancelButtonText')), /*#__PURE__*/React.createElement(Button, {
        disabled: !canSubmit,
        color: "primary",
        size: "sm",
        onClick: this.handleOk
      }, translate('SFxAccountSettingsSaveButtonText'))));
      return /*#__PURE__*/React.createElement(React.Fragment, null, loading && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-mask")
      }, /*#__PURE__*/React.createElement(CommonLoad, {
        size: 0.2
      })), /*#__PURE__*/React.createElement(Modal, {
        centered: true,
        backdrop: "static",
        className: "".concat(prefix, "-plant-modal"),
        title: PlantModalTitle,
        isOpen: isOpen,
        toggle: toggle,
        footer: footer
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        md: "12"
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, translate('SFxAccountSettingsPlantNameLabel')), !(plant.Name && plant.Name.trim()) && /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-require")
      }, "*"), /*#__PURE__*/React.createElement(Input, {
        onBlur: this.onBlurName.bind(this),
        type: "text",
        name: "Name",
        value: plant.Name || "",
        onChange: this.onInputChange,
        maxLength: 50,
        autoComplete: "off"
      })), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-require-message")
      }, nameMsg))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
        md: "12"
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, "  ", translate('SFxAccountSettingsPlantAddressLabel')), /*#__PURE__*/React.createElement(GeoSearch, {
        key: this.state.loadFromName,
        initValue: this.state.initValue,
        subscriptionKey: this.state.subscriptionKey || '',
        onSelect: this.selectAddress,
        defaultValue: plant.Address || ""
      })), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-require-message")
      }, addressMsg)))))));
    }
  }]);

  return PlantModal;
}(Component);

export default PlantModal;